export enum RdxFilterTypes {
    PROJECT = 1,
    RELEASE,
    USER,
    CYCLE,
    REQUIREMENT,
    FEATURE,
    CORRECTION_CATEGORY,
    CORRECTION_TYPE,
    CORRECTION_DEVELOPMENT_CLASS,
    CORRECTION_BUSINESS_FUNCTION,
    CORRECTION_MODULE,
    ITERATION,
    HASHTAG,
    CORRECTION_CATEGORY_OF_ISSUES,
    CORRECTION_TYPE_OF_ISSUES,
    OBJECT_TYPE_OF_ISSUES,
    CUSTOM_TYPE,
    STATUS,
    TECHNICAL_PRIORITY,
    ACCOUNT,
    ACTIVE_PROJECT,
    AGENT_TAGS
}
